import { OrderStatus } from '@features/halalShop/types';

const needPostCodeStatuses: OrderStatus[] = [OrderStatus.WaitTake];

export const isNeedPostCode = (status: OrderStatus) =>
  needPostCodeStatuses.includes(status);
